
  import { Record, Partial, Static, Number, String, Always, Intersect2, Constraint, Literal } from 'runtypes';

  export const ___baseEventTypeDefinition = Record({
  eventId: Literal(93),
  playerId: Number.withConstraint(x => x >= 0),
  accountHash: String.withConstraint(x => x.length <= 32),
  customHash: String.withConstraint(x => x.length <= 32),
  testId: Number.withConstraint(x => x >= -1),
  caseId: Number.withConstraint(x => x >= -1),
  countryCode: String.withConstraint(x => x.length <= 2),
  journeyStep: Number.withConstraint(x => x >= 0),
  userAgent: String.withConstraint(x => x.length <= 250),
  source: Number.withConstraint(x => x >= 0),
  auto: String.withConstraint(x => /$false|true^/.test(x)),
  milliseconds: Number.withConstraint(x => x >= 0),
  recurringUser: Number.withConstraint(x => x >= 0),
  w: Number.withConstraint(x => x >= 0),
  pid: Number.withConstraint(x => x >= 0),
  creative: Number.withConstraint(x => x >= 0),
  placement: String.withConstraint(x => x.length <= 255),
  keyword: String.withConstraint(x => x.length <= 255),
  network: String.withConstraint(x => x.length <= 2),
  cid: String.withConstraint(x => x.length <= 255),
  tid: String.withConstraint(x => x.length <= 255),
  aid: Number.withConstraint(x => x >= 0),
  camp: Number.withConstraint(x => x >= 0),
  adgr: Number.withConstraint(x => x >= 0),
  matchtype: String.withConstraint(x => x.length <= 1),
  gid: Number.withConstraint(x => x >= 0),
  gclid: String.withConstraint(x => x.length <= 100),
  yclid: String.withConstraint(x => x.length <= 20),
  nid: Number.withConstraint(x => x >= 0),
}).And(Partial({
  crna: String.withConstraint(x => x.length <= 100),
  registration_type_id: Number.withConstraint(x => x >= 1 && x <= 10),
  referrer: String.withConstraint(x => x.length <= 255),
  tracking_link: String.withConstraint(x => x.length <= 2048),
}));
  export const ___completeEventTypeDefinition = Record({
  eventId: Literal(93),
  playerId: Number.withConstraint(x => x >= 0),
  accountHash: String.withConstraint(x => x.length <= 32),
  customHash: String.withConstraint(x => x.length <= 32),
  testId: Number.withConstraint(x => x >= -1),
  caseId: Number.withConstraint(x => x >= -1),
  countryCode: String.withConstraint(x => x.length <= 2),
  journeyStep: Number.withConstraint(x => x >= 0),
  userAgent: String.withConstraint(x => x.length <= 250),
  source: Number.withConstraint(x => x >= 0),
  auto: String.withConstraint(x => /$false|true^/.test(x)),
  milliseconds: Number.withConstraint(x => x >= 0),
  recurringUser: Number.withConstraint(x => x >= 0),
  w: Number.withConstraint(x => x >= 0),
  pid: Number.withConstraint(x => x >= 0),
  creative: Number.withConstraint(x => x >= 0),
  placement: String.withConstraint(x => x.length <= 255),
  keyword: String.withConstraint(x => x.length <= 255),
  network: String.withConstraint(x => x.length <= 2),
  cid: String.withConstraint(x => x.length <= 255),
  tid: String.withConstraint(x => x.length <= 255),
  aid: Number.withConstraint(x => x >= 0),
  camp: Number.withConstraint(x => x >= 0),
  adgr: Number.withConstraint(x => x >= 0),
  matchtype: String.withConstraint(x => x.length <= 1),
  gid: Number.withConstraint(x => x >= 0),
  gclid: String.withConstraint(x => x.length <= 100),
  yclid: String.withConstraint(x => x.length <= 20),
  nid: Number.withConstraint(x => x >= 0),
  gameId: Number.withConstraint(x => x >= 1 && x <= 100),
  networkId: Number.withConstraint(x => x >= 0 && x <= 1000),
  instanceId: Number.withConstraint(x => x >= 0 && x <= 1000),
}).And(Partial({
  crna: String.withConstraint(x => x.length <= 100),
  registration_type_id: Number.withConstraint(x => x >= 1 && x <= 10),
  referrer: String.withConstraint(x => x.length <= 255),
  tracking_link: String.withConstraint(x => x.length <= 2048),
  zoneId: Number.withConstraint(x => x >= 0 && x <= 1000),
}));

  export type Event = Static<typeof ___baseEventTypeDefinition>;

  /** The event type with the shared values added */
  export type EventWithCommonParameters = Static<typeof ___completeEventTypeDefinition>;

  export const validateEvent = (o: any) => ___completeEventTypeDefinition.validate(o);

  export const ID = 93;
  